/*
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 按需注入lodash工具
 * @Date: 2021-09-16 11:11:14
 * @LastEditTime: 2021-10-08 13:22:54
 */

import map from "lodash/map"
import sumBy from "lodash/sumBy"
import debounce from "lodash/debounce"
import sum  from "lodash/sum"
import throttle  from "lodash/throttle" 
import cloneDeep from "lodash/cloneDeep"
import groupBy from 'lodash/groupBy'
import find from 'lodash/find'


export default function (app) {
  const obj = {
    map, sumBy, debounce,throttle,sum,cloneDeep,groupBy,find
  }
  app.provide('_', obj);
  app.config.globalProperties._ = obj;
}
